import { render, staticRenderFns } from "./reward-key-config.vue?vue&type=template&id=2f1c1327&scoped=true"
import script from "./reward-key-config.vue?vue&type=script&lang=js"
export * from "./reward-key-config.vue?vue&type=script&lang=js"
import style0 from "./reward-key-config.vue?vue&type=style&index=0&id=2f1c1327&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c1327",
  null
  
)

export default component.exports